class BackInStock extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(document, 'click', this.handleTrigger)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.openModalOnLoad()
  }

  openModalOnLoad () {
    // check if url contains these query parameters '&=open-modal'
    const urlParams = window.location.search.substring(1).split('&=')

    urlParams.forEach(param => {
      if (param === 'open-modal') {
        const trigger = document.querySelector('[data-back-in-stock-external-el="trigger"]')

        if (trigger) {
          trigger.click()
        }
      }
    })
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)
  }

  async handleTrigger (event) {
    const trigger = event.target.closest('[data-back-in-stock-external-el="trigger"]')

    let newVariantTitle = null

    if (this.externalEls.productTitle) {
      newVariantTitle = this.externalEls.productTitle.element.innerText
    }
    if (this.externalEls.variantTitle) {
      newVariantTitle = `${newVariantTitle} - ${this.externalEls.variantTitle.element.innerText}`
    }

    if (trigger) {
      if (trigger.getAttribute('data-back-in-stock-product-title')) {
        newVariantTitle = trigger.getAttribute('data-back-in-stock-product-title')
      }

      if (trigger.getAttribute('data-back-in-stock-variant-title') && trigger.getAttribute('data-back-in-stock-variant-title') !== 'Default Title') {
        newVariantTitle = `${newVariantTitle} - ${trigger.getAttribute('data-back-in-stock-variant-title')}`
      }
    }

    if (newVariantTitle != null) {
      this.els.title.element.innerText = `${newVariantTitle.toLowerCase()}`
    }

    if (!trigger) return

    // Retrieve all modal windows
    const modalWindows = document.querySelectorAll('back-in-stock')

    // Get the ID from the trigger
    const currentTriggerId = trigger.getAttribute('data-back-in-stock-item-trigger-id')

    modalWindows.forEach(modalWindow => {
      const modalWindowId = modalWindow.getAttribute('data-back-in-stock-item-trigger-id')

      // Show the modal if IDs match and hide others
      if (currentTriggerId === modalWindowId) {
        modalWindow.setAttribute('aria-hidden', 'false')
      } else {
        modalWindow.setAttribute('aria-hidden', 'true')
      }
    })
  }
}

if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', BackInStock)
}
